<!--
 * @Descripttion: 
 * @version: 
 * @Author: mrh
 * @Date: 2020-11-12 10:02:34
 * @LastEditors: mrh
 * @LastEditTime: 2021-03-10 10:45:19
-->
<!--
 * @Descripttion: 
 * @version: 
 * @Author: sueRimn
 * @Date: 2020-07-22 09:30:52
 * @LastEditors: mrh
 * @LastEditTime: 2020-11-19 12:04:31
-->

<template>
  <div class="shops" ref="shops">
    <div class="searchs">
      <van-search
        v-model="searchVal"
        shape="round"
        placeholder="请输入商品名称"
        background="#208FFF"
        @focus="gosearch()"
      />
      <van-button type="default" icon="clear" @click="closeHandsel"
        >退出</van-button
      >
    </div>
    <div class="shopsText">
      <img :src="imgPrex + shopDetail.headpic" alt />
      <div>
        <span>{{ shopDetail.name }}({{ shopDetail.shopName }})</span>
        <span>
          <!-- <i class="iconfont icon-zitidian"></i> -->
          自提点：{{ shopDetail.address }}
        </span>
      </div>
      <p @click="share(shopDetail)">
        <i class="iconfont icon-fenxianganniu"></i>
        <!-- <img src="../../assets/img/home_top_icon_share.png" alt /> -->
      </p>
    </div>

    <van-tabs
      v-model="tabsActive"
      class="topTabs"
      :class="{
        sty:
          superHit.catelist.length == 0 ||
          collageData.catelist.length <= 1 ||
          allData.catelist.length <= 1,
      }"
      background="#F9F7F5"
      color="#666666"
      title-active-color="#333333"
    >
      <van-tab title="同城">
        <van-tabs
          v-model="active1"
          class="collage"
          @change="scrollTos"
          swipeable
          sticky
          :offset-top="40"
          v-if="
            superHit.catelist.length > 0 ||
            collageData.catelist.length > 1 ||
            allData.catelist.length > 1
          "
        >
          <van-tab v-if="superHit.catelist.length > 0" title="0">
            <template #title>
              <img src="../../assets/img/zhiding_miaosha.png" alt class="ms" />
              <img
                src="../../assets/img/hd.png"
                alt=""
                class="activeImg"
                v-show="cindex == 0"
              />
            </template>
            <div @touchmove.stop class="smallType">
              <van-tabs
                v-model="supers1"
                :ellipsis="false"
                sticky
                swipe-threshold="4"
                title-active-color="#FF9900"
                title-inactive-color="#666"
                @change="changeCateList(0, supers1, 0)"
              >
                <van-tab
                  v-for="(item, index) in superHit.catelist"
                  :key="index"
                  :title="item.date"
                  :name="item.time"
                ></van-tab>
              </van-tabs>
            </div>

            <div
              v-for="(item, index) in superHit.list"
              :key="index"
              class="collagelist"
              @click="goDetails(index, item.sellerProductGoodsId)"
            >
              <van-image lazy-load :src="imgPrex + item.imageUrl" />
              <p class="overlys" v-show="item.stock == 0">
                <span>已售罄</span>
              </p>
              <div class="tags">
                {{ item.sellerName }}
              </div>
              <div class="texts">
                <div class="shareName">
                  <span class="names">{{ item.name }}</span>
                  <!-- <van-count-down
                    :time="item.countDown * 1000"
                    v-show="item.type != 5"
                    format="结束时间 MMDD天HH:mm:ss"
                  /> -->
                  <span class="times" v-show="item.type != 5">结束时间 {{ item.countDown }}</span>
                </div>
                <div class="msdiv">
                  <p class="prices">
                    <span>￥{{ item.price }}</span>
                    <span>{{ item.guidePrice }}</span>
                    <span
                      class="commission"
                      v-show="item.communityShopMoney > 0"
                      >佣金:¥{{ item.communityShopMoney }}</span
                    >
                  </p>
                </div>

                <div class="share">
                  <i class="icon-fenxiang iconfont"></i>
                  <span class="money" @click.stop="share(item)"
                    >分享{{
                      item.sharePromotionContent != "" && item.shareMoney > 0
                        ? `赚同款及${item.shareMoney}`
                        : item.shareMoney > 0 &&
                          item.sharePromotionContent == ""
                        ? `赚¥${item.shareMoney}`
                        : item.sharePromotionContent != ""
                        ? `赚同款`
                        : ``
                    }}</span
                  >
                  <!-- <van-button color="#FF514E" plain @click.stop="share(item)">分享</van-button> -->
                  <!-- <van-button color="#FF514E" plain @click.stop="share(item)">分享</van-button> -->
                </div>
                <div class="btn_group">
                  <van-button
                    color="#208FFF"
                    @click.stop="getGoodsDesc(item.spgExId)"
                    class="copy"
                    v-if="item.spgExId != 0"
                    >复制推广文案</van-button
                  >
                </div>
              </div>
            </div>
          </van-tab>
          <van-tab v-if="collageData.catelist.length > 1" title="1">
            <template #title>
              <img
                src="../../assets/img/zhiding_pinpianyi.png"
                alt
                class="ms"
              />
              <img
                src="../../assets/img/hd.png"
                alt=""
                class="activeImg"
                v-show="cindex == 1"
              />
            </template>
            <div @touchmove.stop class="smallType">
              <van-tabs
                v-model="collage1"
                :ellipsis="false"
                sticky
                swipe-threshold="4"
                title-active-color="#FF9900"
                title-inactive-color="#666"
                @change="changeCateList(1, collage1, 0)"
              >
                <van-tab
                  v-for="(item, index) in collageData.catelist"
                  :key="index"
                  :title="item.cateName"
                  :name="item.cateId"
                ></van-tab>
              </van-tabs>
            </div>

            <div
              v-for="(item, index) in collageData.list"
              :key="index"
              class="collagelist"
              @click="goDetails(index, item.sellerProductGoodsId)"
            >
              <van-image lazy-load :src="imgPrex + item.imageUrl" />
              <p class="overlys" v-show="item.stock == 0">
                <!-- <img :src="prefixURL + 'mobile/img/mp/sellout.png'" alt /> -->
                <span>已售罄</span>
              </p>
              <div class="numbers">
                <p
                  class="nums"
                  v-show="
                    item.hadBoughtNum == 0 && item.type != 5 && item.type != 6
                  "
                >
                  差<span>{{ item.minNum - item.hadBoughtNum }}</span
                  >份
                </p>
                <p
                  class="nums"
                  v-show="
                    item.minNum - item.hadBoughtNum == 0 &&
                    item.type != 5 &&
                    item.type != 6
                  "
                >
                  已拼<span>{{ item.hadBoughtNum }}</span>
                </p>
              </div>
              <div class="tags">
                {{ item.sellerName }}
              </div>
              <div class="texts">
                <div class="shareName">
                  <span class="names">{{ item.name }}</span>
                  <div class="countDown">
                    <!-- <van-count-down
                      :time="item.countDown * 1000"
                      v-show="item.type != 5"
                      format="距结束 DD天HH:mm:ss"
                    /> -->
                    <span class="times" v-show="item.type != 5">结束时间 {{ item.countDown }}</span>
                  </div>
                </div>
                <div>
                  <div class="prices">
                    <span>￥{{ item.price }}</span>
                    <span>{{ item.guidePrice }}</span>
                    <span
                      class="commission"
                      v-show="item.communityShopMoney > 0"
                      >佣金:¥{{ item.communityShopMoney }}</span
                    >
                  </div>

                  <!-- <p class="shopmoney">
                <
              </p>-->
                </div>
                <div class="share">
                  <i class="icon-fenxiang iconfont"></i>
                  <span class="money" @click.stop="share(item)"
                    >分享{{
                      item.sharePromotionContent != "" && item.shareMoney > 0
                        ? `赚同款及${item.shareMoney}`
                        : item.shareMoney > 0 &&
                          item.sharePromotionContent == ""
                        ? `赚¥${item.shareMoney}`
                        : item.sharePromotionContent != ""
                        ? `赚同款`
                        : ``
                    }}</span
                  >
                  <!-- <van-button color="#FF514E" plain @click.stop="share(item)">分享</van-button> -->
                  <!-- <van-button color="#FF514E" plain @click.stop="share(item)">分享</van-button> -->
                </div>

                <div class="btn_group">
                  <van-button
                    color="#208FFF"
                    @click.stop="getGoodsDesc(item.spgExId)"
                    class="copy"
                    v-if="item.spgExId != 0"
                    >复制推广文案</van-button
                  >
                </div>
              </div>
            </div>
          </van-tab>
          <van-tab v-if="allData.catelist.length > 1" title="2">
            <template #title>
              所有商品
              <img
                src="../../assets/img/hd.png"
                alt=""
                class="activeImg"
                v-show="cindex == 2"
              />
            </template>
            <div @touchmove.stop class="smallType">
              <van-tabs
                v-model="allGoods"
                :ellipsis="false"
                sticky
                swipe-threshold="4"
                title-active-color="#FF9900"
                title-inactive-color="#666"
                @change="changeCateList(2, allGoods, 0)"
              >
                <van-tab
                  v-for="(item, index) in allData.catelist"
                  :key="index"
                  :title="item.cateName"
                  :name="item.cateId"
                ></van-tab>
              </van-tabs>
            </div>

            <div
              v-for="(item, index) in allData.list"
              :key="index"
              class="collagelist"
              @click="goDetails(index, item.sellerProductGoodsId)"
            >
              <van-image lazy-load :src="imgPrex + item.imageUrl" />
              <p class="overlys" v-show="item.stock == 0">
                <!-- <img :src="prefixURL + 'mobile/img/mp/sellout.png'" alt /> -->
                <span>已售罄</span>
              </p>
              <div
                class="numbers"
                v-if="
                  (item.hadBoughtNum == 0 ||
                    item.minNum - item.hadBoughtNum == 0) &&
                  item.type != 5 &&
                  item.type != 6
                "
              >
                <!-- <van-count-down
                  :time="item.countDown * 1000"
                  v-show="item.type != 5"
                  format="距结束 DD天HH:mm:ss"
                /> -->
                <!-- <span class="times">结束时间 {{ item.countDown }}</span> -->
                <p class="nums" v-show="item.hadBoughtNum == 0">
                  差<span>{{ item.minNum - item.hadBoughtNum }}</span
                  >份
                </p>
                <p class="nums" v-show="item.minNum - item.hadBoughtNum == 0">
                  拼<span>{{ item.hadBoughtNum }}</span>
                </p>
              </div>
              <div class="tags">
                {{ item.sellerName }}
              </div>
              <div class="texts">
                <div class="shareName">
                  <span class="names">{{ item.name }}</span>
                  <div class="countDown">
                    <!-- <van-count-down
                      :time="item.countDown * 1000"
                      v-show="item.type != 5"
                      format="距结束 DD天HH:mm:ss"
                    /> -->
                    <span class="times" v-show="item.type != 5">结束时间 {{ item.countDown }}</span>
                  </div>
                </div>
                <div>
                  <div class="prices">
                    <span>￥{{ item.price }}</span>
                    <span>{{ item.guidePrice }}</span>
                    <span
                      class="commission"
                      v-show="item.communityShopMoney > 0"
                      >佣金:¥{{ item.communityShopMoney }}</span
                    >
                  </div>
                  <!-- <div class="shopmoney">
                
              </div>-->
                </div>

                <div class="share">
                  <i class="icon-fenxiang iconfont"></i>
                  <span class="money" @click.stop="share(item)"
                    >分享{{
                      item.sharePromotionContent != "" && item.shareMoney > 0
                        ? `赚同款及${item.shareMoney}`
                        : item.shareMoney > 0 &&
                          item.sharePromotionContent == ""
                        ? `赚¥${item.shareMoney}`
                        : item.sharePromotionContent != ""
                        ? `赚同款`
                        : ``
                    }}</span
                  >
                </div>

                <div class="btn_group">
                  <van-button
                    color="#208FFF"
                    @click.stop="getGoodsDesc(item.spgExId)"
                    class="copy"
                    v-if="item.spgExId != 0"
                    >复制推广文案</van-button
                  >
                  <!-- <van-button
                    color="#FF9A34"
                    plain
                    @click.stop="recommendAdd(item.sellerProductGoodsId)"
                    >取消推荐</van-button
                  > -->
                </div>
              </div>
            </div>
          </van-tab>
          <span>更多商品上架中</span>
        </van-tabs>
        <div v-else class="nulls">
          <i class="icon-personal_image_nothi iconfont"></i>
          <span> 暂无同城商品，请尽情期待 </span>
        </div>
      </van-tab>
      <van-tab title="全国">
        <van-tabs
          v-model="active2"
          class="collage"
          @change="scrollTos2"
          swipeable
          sticky
          :offset-top="40"
          v-if="
            qsuperHit.catelist.length > 0 ||
            qcollageData.catelist.length > 1 ||
            storeRecommendData.catelist.length > 1
          "
        >
          <van-tab v-if="qsuperHit.catelist.length > 0" title="0">
            <template #title>
              <img src="../../assets/img/zhiding_miaosha.png" alt class="ms" />
              <img
                src="../../assets/img/hd.png"
                alt=""
                class="activeImg"
                v-show="cindexs == 0"
              />
            </template>
            <div @touchmove.stop class="smallType">
              <van-tabs
                v-model="supers"
                :ellipsis="false"
                sticky
                swipe-threshold="4"
                title-active-color="#FF9900"
                title-inactive-color="#666"
                @change="changeCateList(0, supers, 1)"
              >
                <van-tab
                  v-for="(item, index) in qsuperHit.catelist"
                  :key="index"
                  :title="item.date"
                  :name="item.time"
                ></van-tab>
              </van-tabs>
            </div>

            <div
              v-for="(item, index) in qsuperHit.list"
              :key="index"
              class="collagelist"
              @click="goDetails(index, item.sellerProductGoodsId)"
            >
              <van-image lazy-load :src="imgPrex + item.imageUrl" />
              <p class="overlys" v-show="item.stock == 0">
                <!-- <img :src="prefixURL + 'mobile/img/mp/sellout.png'" alt /> -->
                <span>已售罄</span>
              </p>
              <div class="tags">
                {{ item.sellerName }}
              </div>
              <div class="texts">
                <div class="shareName">
                  <span class="names">{{ item.name }}</span>
                  <!-- <span
                v-show="item.sharePromotionContent != ''"
                class="shareContent"
              >{{item.sharePromotionContent}}</span>-->
                  <!-- <van-count-down
                    :time="item.countDown * 1000"
                    v-show="item.type != 5"
                    format="距结束 DD天HH:mm:ss"
                  /> -->
                  <span class="times" v-show="item.type != 5">结束时间 {{ item.countDown }}</span>
                </div>
                <div class="msdiv">
                  <p class="prices">
                    <span>￥{{ item.price }}</span>
                    <span>{{ item.guidePrice }}</span>
                    <span
                      class="commission"
                      v-show="item.communityShopMoney > 0"
                      >佣金:¥{{ item.communityShopMoney }}</span
                    >
                  </p>
                </div>
                <div class="share">
                  <i class="icon-fenxiang iconfont"></i>
                  <span class="money" @click.stop="share(item)"
                    >分享{{
                      item.sharePromotionContent != "" &&
                      item.hasOwnProperty("sharePromotionContent")
                        ? item.shareMoney > 0
                          ? `赚同款及${item.shareMoney}`
                          : item.shareMoney > 0
                          ? `赚¥${item.shareMoney}`
                          : ``
                        : ""
                    }}</span
                  >
                  <!-- <van-button color="#FF514E" plain @click.stop="share(item)">分享</van-button> -->
                  <!-- <van-button color="#FF514E" plain @click.stop="share(item)">分享</van-button> -->
                </div>
                <div class="btn_group">
                  <van-button
                    color="#208FFF"
                    @click.stop="getGoodsDesc(item.spgExId)"
                    class="copy"
                    v-if="item.spgExId != 0"
                    >复制推广文案</van-button
                  >
                </div>
              </div>
            </div>
          </van-tab>
          <van-tab v-if="qcollageData.catelist.length > 1" title="1">
            <template #title>
              <img
                src="../../assets/img/zhiding_pinpianyi.png"
                alt
                class="ms"
              />
              <img
                src="../../assets/img/hd.png"
                alt=""
                class="activeImg"
                v-show="cindexs == 1"
              />
            </template>
            <div @touchmove.stop class="smallType">
              <van-tabs
                v-model="collage"
                :ellipsis="false"
                sticky
                swipe-threshold="4"
                title-active-color="#FF9900"
                title-inactive-color="#666"
                @change="changeCateList(1, collage, 1)"
              >
                <van-tab
                  v-for="(item, index) in qcollageData.catelist"
                  :key="index"
                  :title="item.cateName"
                  :name="item.cateId"
                ></van-tab>
              </van-tabs>
            </div>

            <div
              v-for="(item, index) in qcollageData.list"
              :key="index"
              class="collagelist"
              @click="goDetails(index, item.sellerProductGoodsId)"
            >
              <van-image lazy-load :src="imgPrex + item.imageUrl" />
              <p class="overlys" v-show="item.stock == 0">
                <!-- <img :src="prefixURL + 'mobile/img/mp/sellout.png'" alt /> -->
                <span>已售罄</span>
              </p>
              <div
                class="numbers"
                v-if="
                  (item.hadBoughtNum == 0 ||
                    item.minNum - item.hadBoughtNum == 0) &&
                  item.type != 5 &&
                  item.type != 6
                "
              >
                <p class="nums" v-show="item.hadBoughtNum == 0">
                  差<span>{{ item.minNum - item.hadBoughtNum }}</span
                  >份
                </p>
                <p class="nums" v-show="item.minNum - item.hadBoughtNum == 0">
                  已拼<span>{{ item.hadBoughtNum }}</span>
                </p>
              </div>
              <div class="tags">
                {{ item.sellerName }}
              </div>
              <div class="texts">
                <div class="shareName">
                  <span class="names">{{ item.name }}</span>
                  <div class="countDown">
                    <!-- <van-count-down
                      :time="item.countDown * 1000"
                      v-show="item.type != 5"
                      format="距结束 DD天HH:mm:ss"
                    /> -->
                    <span class="times" v-show="item.type != 5">结束时间 {{ item.countDown }}</span>
                  </div>
                </div>
                <div>
                  <div class="prices">
                    <span>￥{{ item.price }}</span>
                    <span>{{ item.guidePrice }}</span>
                    <span
                      class="commission"
                      v-show="item.communityShopMoney > 0"
                      >佣金:¥{{ item.communityShopMoney }}</span
                    >
                  </div>

                  <!-- <p class="shopmoney">
                <
              </p>-->
                </div>
                <div class="share">
                  <i class="icon-fenxiang iconfont"></i>
                  <span class="money" @click.stop="share(item)"
                    >分享{{
                      item.sharePromotionContent != "" &&
                      item.hasOwnProperty("sharePromotionContent")
                        ? item.shareMoney > 0
                          ? `赚同款及${item.shareMoney}`
                          : item.shareMoney > 0
                          ? `赚¥${item.shareMoney}`
                          : ``
                        : ""
                    }}</span
                  >
                  <!-- <van-button color="#FF514E" plain @click.stop="share(item)">分享</van-button> -->
                  <!-- <van-button color="#FF514E" plain @click.stop="share(item)">分享</van-button> -->
                </div>

                <div class="btn_group">
                  <van-button
                    color="#208FFF"
                    @click.stop="getGoodsDesc(item.spgExId)"
                    class="copy"
                    v-if="item.spgExId != 0"
                    >复制推广文案</van-button
                  >
                </div>
              </div>
            </div>
          </van-tab>
          <van-tab v-if="storeRecommendData.catelist.length > 1" title="2">
            <template #title>
              店长推荐
              <img
                src="../../assets/img/hd.png"
                alt=""
                class="activeImg"
                v-show="cindexs == 2"
              />
            </template>
            <div @touchmove.stop class="smallType">
              <van-tabs
                v-model="storeRecommend"
                :ellipsis="false"
                sticky
                swipe-threshold="4"
                title-active-color="#FF9900"
                title-inactive-color="#666"
                @change="changeCateList(2, storeRecommend, 1)"
              >
                <van-tab
                  v-for="(item, index) in storeRecommendData.catelist"
                  :key="index"
                  :title="item.cateName"
                  :name="item.cateId"
                ></van-tab>
              </van-tabs>
            </div>

            <div
              v-for="(item, index) in storeRecommendData.list"
              :key="index"
              class="collagelist"
              @click="goDetails(index, item.sellerProductGoodsId)"
            >
              <van-image lazy-load :src="imgPrex + item.imageUrl" />
              <p class="overlys" v-show="item.stock == 0">
                <!-- <img :src="prefixURL + 'mobile/img/mp/sellout.png'" alt /> -->
                <span>已售罄</span>
              </p>
              <div class="tags">
                {{ item.sellerName }}
              </div>
              <div class="texts">
                <div class="shareName" style="flex-flow: row">
                  <span class="names">{{ item.name }}</span>
                  <!-- <van-button
                color="#F23239"
                :plain="item.isPP == 1 ? true : false"
                @click.stop="promotion(item.sellerProductGoodsId, item.isPP)"
                >{{ item.isPP == 0 ? "推广" : "取消推广" }}</van-button
              > -->
                </div>
                <div>
                  <p class="prices">
                    <span>￥{{ item.price }}</span>
                    <span>{{ item.guidePrice }}</span>
                    <span
                      class="commission"
                      v-show="item.communityShopMoney > 0"
                      >佣金:¥{{ item.communityShopMoney }}</span
                    >
                  </p>
                </div>

                <div class="share closes">
                  <div>
                    <i class="icon-fenxiang iconfont"></i>
                    <span class="money" @click.stop="share(item)"
                      >分享{{
                        item.sharePromotionContent != "" &&
                        item.hasOwnProperty("sharePromotionContent")
                          ? item.shareMoney > 0
                            ? `赚同款及${item.shareMoney}`
                            : item.shareMoney > 0
                            ? `赚¥${item.shareMoney}`
                            : ``
                          : ""
                      }}</span
                    >
                  </div>
                </div>
                <div class="btn_group">
                  <van-button
                    color="#208FFF"
                    @click.stop="getGoodsDesc(item.spgExId)"
                    class="copy"
                    v-if="item.spgExId != 0"
                    >复制推广文案</van-button
                  >
                  <van-button
                    color="#FF9A34"
                    plain
                    @click.stop="recommendAdd(item.sellerProductGoodsId)"
                    >取消推荐</van-button
                  >
                </div>
              </div>
            </div>
          </van-tab>
          <span>更多商品上架中</span>
        </van-tabs>
        <div v-else class="nulls">
          <i class="icon-personal_image_nothi iconfont"></i>
          <span @click="goPros()" style="color: #208fff">获取更多商品</span>
        </div>
      </van-tab>
    </van-tabs>
    <div id="copy-txt" v-html="description"></div>
    <share-popup
      :good-obj="shareObj"
      :show-popup="showPopup"
      @hidePopup="showPopups"
    />
  </div>
</template>
<script>
import {
  getCommunityShopById,
  seckillList,
  collageOrderList,
  recommendProductList,
  recommendAdd,
  partnerList,
  shopInfo,
  promotion,
  getGoodsDesc,
} from "@/api/join";
import goodsList from "@/components/list/list"; //
import sharePopup from "@/components/share/share"; //分享组件
export default {
  components: {
    goodsList,
    sharePopup,
  },
  data() {
    return {
      // headerMsg: {},
      searchVal: "",
      shopDetail: {},
      // reservationList2: [],
      active1: 0,
      active2: 0,
      // datas: [
      //   { title: "超级爆款", catelist: [], list: [], id: "0" },
      //   { title: "拼便宜", catelist: [], list: [], id: "1" },
      //   { title: "同城热销", catelist: [], list: [], id: "2" },
      //   { title: "店长推荐", catelist: [], list: [], id: "3" }
      // ],
      superHit: { catelist: [], list: [], id: "0" }, //同城秒杀
      collageData: { catelist: [], list: [], id: "1" }, //同城拼单
      allData: { catelist: [], list: [], id: "2" }, //同城所有
      qsuperHit: { catelist: [], list: [], id: "2" }, //全国秒杀
      qcollageData: { catelist: [], list: [], id: "1" }, //全国拼单
      storeRecommendData: { catelist: [], list: [], id: "3" }, //厂家推荐
      supers: "", //全国秒杀model
      supers1: "", //同城爆款model
      collage: "", //全国拼便宜model
      collage1: "", //同城拼便宜model
      allGoods: "", //同城所有商品model
      storeRecommend: "", //店家推荐model
      shareObj: {}, //分享弹窗obj
      showPopup: false, //分享弹窗展示
      threeCateId: "", //三级分类index
      isTj: false, //是否点击推荐/取消推荐
      isPromotion: false, //是否点击推广/取消推广
      ids: "",
      cindex: "", //同城选中的tab下标
      cindexs: "", //全国选中的tab下标
      tabsActive: "", //同城/全国的下标
      description: "", //商品推广文案信息
    };
  },
  mounted() {
    // this.copyTXT()
  },
  created() {
    this.shopInfo();
  },
  methods: {
    // 获取全国秒杀列表接口
    seckillList(id) {
      let obj = {
        communityShopId: this.$store.getters.communityShopId, //店长id,如果是去我的店铺中的更多预约商品，这里传0，后台根据token去拿到用户的店铺信息
        flag: 0, //0超值爆款（只查询爆款商品,可买）， 1.爆款预告(不可买)
        seckillTime: id, //时间
        page: {
          way: "0", // 0:不分页 1:分页
          index: "1", //请求页
          size: "100", //请求大小
        },
      };
      seckillList(obj).then((res) => {
        if (res.content.list.length > 0) {
          res.content.list.forEach((el) => {
            el.countDown = this.set_time(el.countDown);
          });
          this.qsuperHit.list = res.content.list;
        }
      });
    },
    // 获取全国拼单列表接口
    collageOrderList(id) {
      let obj = {
        communityShopId: this.$store.getters.communityShopId, //社区店长id
        cateId: id || "0", //商品分类的2级分类,0表示拿取所有分类
        page: {
          way: "0", // 0:不分页 1:分页
          index: "1", //请求页
          size: "100", //请求大小
        },
      };
      collageOrderList(obj).then((res) => {
        // console.log(res);
        if (res.content.list.length > 0) {
          res.content.list.forEach((el) => {
            el.countDown = this.set_time(el.countDown);
          });
          this.qcollageData.list = res.content.list;
        }
      });
    },
    // 获取全国的店长推荐商品列表的接口
    recommendProductList(id) {
      // console.log(id,'2')
      let obj = {
        communityShopId: this.$store.getters.communityShopId, //社区店长id
        cateId: id || "0", //商品分类的2级分类,0表示拿取所有分类
        page: {
          way: "0", // 0:不分页 1:分页
          index: "1", //请求页
          size: "100", //请求大小
        },
      };
      this.ids = id;
      recommendProductList(obj).then((res) => {
        // console.log(res);
        res.content.list.forEach((el) => {
          el.countDown = this.set_time(el.countDown);
        });
        if (res.content.list.length > 0) {
          this.storeRecommendData.list = res.content.list;
        } else {
          this.storeRecommendData.list = res.content.list;
          this.storeRecommend =
            this.storeRecommendData.catelist.length > 0
              ? this.storeRecommendData.catelist[0].cateId
              : "";
        }
      });
    },
    //获取同城秒杀/拼单/所有商品
    /*
     *
     */
    partnerList(id, type, seckillTime) {
      let obj = {
        communityShopId: this.$store.getters.communityShopId, //社区店长id
        cateId: id || "0", //商品分类的2级分类,0表示拿取所有分类
        type, //283新增参数，后台需要做判空出来，为null则返回以前的结果， 1同城商品，2同城秒杀，3同城拼单
        seckillTime, //时间，后台拿到就变成区间 2020-09-21 00:00:00 2020-09-21 23:59:59，注意283新增参数，283必须传，不然返回结果和之前一样
        page: {
          way: "0", // 0:不分页 1:分页
          index: "1", //请求页
          size: "100", //请求大小
        },
      };
      partnerList(obj).then((res) => {
        if (res.content.list.length > 0) {
          res.content.list.forEach((el) => {
            let states = Object.keys(el.collageOrder).length > 0 ? true : false;
            el.sharePromotionContent = !states
              ? el.fastSelling.sharePromotionContent
                ? el.fastSelling.sharePromotionContent
                : ""
              : "";
            if (el.countDown) {
              el.countDown = this.set_time(el.countDown);
            } else {
              el.countDown = states
                ? el.collageOrder.countDown
                : el.fastSelling.countDown;
              el.countDown = this.set_time(el.countDown);
            }

            el.minNum = states ? el.collageOrder.minNum : 0;
            el.hadBoughtNum = states ? el.collageOrder.hadBoughtNum : 0;
            delete el.fastSelling;
            delete el.collageOrder;
          });
          // this.cityHotData.list = res.content.list;
          switch (type) {
            case 2:
              // console.log(res.content.list)
              this.superHit.list = res.content.list;
              break;
            case 3:
              this.collageData.list = res.content.list;
            case 1:
              // console.log(res.content.list)
              this.allData.list = res.content.list;
            default:
              break;
          }
        }
      });
    },

    set_time(str) {
      let t = Date.parse(new Date()) / 1000;
      let n = (parseInt(str) + t) * 1000;
      let D = new Date(n);
      // let year = D.getFullYear();//四位数年份

      let month = D.getMonth() + 1; //月份(0-11),0为一月份
      // month = month < 10 ? ('0' + month) : month;

      let day = D.getDate(); //月的某一天(1-31)
      day = day < 10 ? "0" + day : day;

      let hours = D.getHours(); //小时(0-23)
      hours = hours < 10 ? "0" + hours : hours;

      let minutes = D.getMinutes(); //分钟(0-59)
      minutes = minutes < 10 ? "0" + minutes : minutes;

      // var seconds = D.getSeconds();//秒(0-59)
      // seconds = seconds<10?('0'+seconds):seconds;
      // var week = D.getDay();//周几(0-6),0为周日
      // var weekArr = ['周日','周一','周二','周三','周四','周五','周六'];
      // this.setData({
      //   dates: `${month} 月 ${day} 日`,//年月
      //   hours,//小时
      //   minutes,//分
      //   times:`${month}月${day}日${hours}:${minutes}`
      // })
      let now_time = `${month}月${day}日${hours}:${minutes}`;
      console.log(now_time);
      return now_time;
    },
    changeCateList(index, id, type) {
      // console.log(index,id,type)
      if (type) {
        switch (index) {
          case 0:
            this.seckillList(id);
            break;
          case 1:
            this.collageOrderList(id);
            break;
          case 2:
            this.threeCateId = id;
            this.recommendProductList(id);
            break;
          default:
            break;
        }
      } else {
        switch (index) {
          case 0:
            this.partnerList(0, 2, id);
            break;
          case 1:
            this.partnerList(id, 3, "");
            break;
          case 2:
            this.partnerList(id, 1, "");
            break;
          default:
            break;
        }
      }
    },
    getCommunityShopById(id) {
      let obj = {
        // token: "", //token id
        communityShopId: id || this.$store.getters.communityShopId, //店长id,如果是去我的店铺，这里传0，后台根据token去拿到用户的店铺信息
        position: {
          // 无法获取经纬度信息时,两个值都传-1 ,后台按默认值定位处理
          longitude: this.$store.getters.longitude,
          latitude: this.$store.getters.latitude,
        },
        iconType: "0", //；如果没有传默认为0； 0、app 1、小程序
      };
      getCommunityShopById(obj).then((res) => {
        // console.log(res);
        this.shopDetail = res.content.shopDetail;

        // 同城秒杀时间列表转换的二级分类
        this.superHit.catelist = this.paseTimes(res.content.ptFastSellingTime);
        // 全国秒杀时间列表转换的二级分类
        this.qsuperHit.catelist = this.paseTimes(res.content.fastSellingTime);

        // 同城拼单二级分类
        this.collageData.catelist = [
          ...[{ cateId: "0", cateName: "全部" }],
          ...res.content.ptCOCateList,
        ];
        // 同城所有商品的二级分类
        this.allData.catelist = [
          ...[{ cateId: "0", cateName: "全部" }],
          ...res.content.ptCateList,
        ];
        // 全国厂家推荐的二级分类
        this.storeRecommendData.catelist = [
          ...[{ cateId: "0", cateName: "全部" }],
          ...res.content.recommendCateList,
        ];
        this.qcollageData.catelist = [
          ...[{ cateId: "0", cateName: "全部" }],
          ...res.content.collageOrderCateList,
        ];
        // this.reservationList2 = res.content.fastSellingForeshowList;
        if (this.isTj || this.$store.getters.recommend) {
          return;
        }
        // 获取全国秒杀的商品列表
        if (res.content.fastSellingTime.length > 0) {
          this.seckillList(res.content.fastSellingTime[0]);
        }

        // 获取全国拼单的商品列表
        this.collageOrderList(0);
        // 获取同城秒杀的商品列表
        this.partnerList(
          0,
          2,
          this.superHit.catelist.length > 0
            ? this.superHit.catelist[0].time
            : ""
        );
        // 获取同城拼单的商品列表
        this.partnerList(0, 3, "");
        // 获取同城所有普通商品的商品列表
        this.partnerList(0, 1, "");
        //店长推荐
        this.recommendProductList(0);
        // res.content.recommendCateList.length > 0? res.content.recommendCateList[0].cateId: "0"
      });
    },
    getNowFormatDate() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = `${year}-${month}-${strDate}`;
      return currentdate;
    },
    gosearch() {
      this.$router.push("/searchGoods");
    },
    gonotice() {
      this.$router.push("/notice");
    },
    //路由跳转
    goPros() {
      this.$router.push("/search");
    },
    recommendAdd(id) {
      if (this.$store.getters.states == "4") {
        this.$toast("您已被冻结");
        return;
      }
      let obj = {
        sellerProductGoodsId: id, //sellerProductGoodsId
        isRec: "0", //1推荐， 0取消推荐
      };
      recommendAdd(obj).then((res) => {
        this.changeCateList(2, this.threeCateId, 1);
        this.isTj = true;
        this.getCommunityShopById();
      });
    },
    share(e) {
      if (e.stock == 0) {
        return;
      }
      // console.log(this.imgPrex + this.shopDetail.headpic);
      this.$refs.shops.style["-webkit-overflow-scrolling"] = "auto";
      if (e.headpic) {
        e.imageUrl = e.headpic;
        e.shareType = "1";
        // delete e.headpic;
      } else {
        e.shareType = "0";
      }
      this.showPopup = true;
      this.shareObj = e;
    },
    goDetails(index, sellerProductGoodsId) {
      this.$router.push({
        path: "/goodsMsg",
        query: {
          index,
          sellerProductGoodsId,
        },
      });
    },
    showPopups(bol) {
      // console.log(bol)
      this.showPopup = bol;
      this.$refs.shops.style["-webkit-overflow-scrolling"] = "touch";
    },
    shopInfo() {
      shopInfo({}).then((res) => {
        this.$store.commit(
          "user/SET_communityShopId",
          res.content.communityShopId
        );
        this.$store.commit("user/SET_name", res.content.name);
        this.$store.commit("user/SET_states", res.content.state);
        this.getCommunityShopById();
      });
    },
    // 同城商品tab
    scrollTos(name, title) {
      this.cindex = title;
      this.$refs.shops.scrollTop = 60;
    },
    // 全国商品tab
    scrollTos2(name, title) {
      this.cindexs = title;
      this.$refs.shops.scrollTop = 60;
    },
    closeHandsel() {
      // url有值时路由跳转
      if (this.$route.meta.headerBack) {
        if (this.$store.getters.ambientType == 1) {
          window.Android.closeHandsel();
        } else if (this.$store.getters.ambientType == 2) {
          window.webkit.messageHandlers.closeHandsel.postMessage("");
        }
        return;
      }
      this.$router.go(-1);
    },
    promotion(spgId, isPP) {
      this.isPromotion = !this.isPromotion;
      let obj = {
        spgId, //sellerProductGoodsId
      };
      promotion(obj).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.$toast(isPP == 0 ? "推广成功" : "取消推广成功");
          this.recommendProductList(this.ids);
        }
      });
    },

    // 时间格式转换
    paseTimes(date) {
      let times = [];
      date.forEach((el) => {
        let t = new Date(el);
        let obj = {};
        // console.log(t.getTime(t),new Date(this.getNowFormatDate()).getTime())
        if (t.getTime(t) == new Date(this.getNowFormatDate()).getTime()) {
          obj.date = `今日`;
          obj.time = el;
          times.push(obj);
        } else if (
          t.getTime(t) ==
          new Date(this.getNowFormatDate()).getTime() + 24 * 60 * 60 * 1000
        ) {
          obj.date = `明日`;
          obj.time = el;
          times.push(obj);
        } else {
          obj.date = `${el.split("-")[1]}月${el.split("-")[2]}日`;
          obj.time = el;
          times.push(obj);
        }
      });
      return times;
    },

    getGoodsDesc(spgExId) {
      getGoodsDesc({
        spgExId, //商品推广文案的id
      }).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.description = "";
          this.description = res.content.description;
          setTimeout(() => {
            this.copyTXT();
          }, 200);
        }
      });
    },

    copyTXT() {
      window.getSelection().removeAllRanges(); // 移除选中的元素
      var copyDOM = document.querySelector("#copy-txt"); //指定的DOM元素
      var range = document.createRange(); // 创建容器
      range.selectNode(copyDOM); // 选中需要复制的节点
      window.getSelection().addRange(range); // 执行选中元素
      var successful = document.execCommand("copy"); // 执行 copy 操作
      try {
        var msg = successful ? "复制成功" : "复制失败";
        // console.log("Copy was " + msg);
        this.$toast(msg);
      } catch (err) {
        // console.log("unable to copy");
      }
    },
  },
  computed: {
    // fdata() {
    //   // 返回视频名称
    //   this.datas = this.datas.filter(el=>{
    //     return el.length
    //   });
    //   return this.datas
    // }
  },
  activated() {
    // console.log(this.$store.getters.recommend, this.threeCateId);
    if (
      this.$store.getters.recommend &&
      this.threeCateId.length > 0 &&
      this.threeCateId
    ) {
      this.getCommunityShopById();
      this.recommendProductList(this.threeCateId);
    }
    // 重置状态
    setTimeout(() => {
      this.$store.commit("user/SET_recommend", false);
    }, 200);
    // this.communiyObj.address = this.$route.query.address == undefined ?'':this.$route.query.address;
    // this.lng = this.$route.query.lng;
    // this.lat = this.$route.query.lat;
  },
};
</script>
<style lang="scss" scoped>
$tx-color: #ff1310;
$fs-color: #1d1d1d;
.shops {
  width: 100%;
  height: calc(100% - 50px);
  background: #f4f4f4;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  .searchs {
    width: 100%;
    height: 44px;
    position: fixed;
    display: flex;
    align-items: center;
    background: #208fff;
    z-index: 99;
    .van-search {
      padding: 2px 0;
      // position: fixed;
      width: 293px;
      z-index: 99;
      margin-left: 10px;
      .van-cell {
        padding: 4px;
      }
    }
    .van-button {
      width: 49px;
      height: 25px;
      padding: 0;
      border-radius: 16px;
      position: absolute;
      right: 15px;
      z-index: 88;
      i {
        color: #999;
        font-size: 16px;
      }
      .van-button__text {
        font-size: 12px;
        margin-left: 2px;
      }
    }
  }
  .shopsText {
    width: auto;
    height: 50px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    background: #208fff;
    margin-top: 44px;
    > img {
      width: 35px;
      height: 35px;
      margin-right: 6px;
      border-radius: 50px;
      object-fit: cover;
    }
    > div {
      width: 260px;
      display: flex;
      flex-flow: column;
      margin-right: 6px;
      span:first-child {
        color: $fs-color;
        font-size: 14px;
        font-weight: bold;
        padding-top: 2px;
        color: #fff;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      span:nth-child(2) {
        color: #ffffff;
        font-size: 10px;
        // height: 40px;
        padding: 2px 0;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
    > p {
      display: flex;
      flex-flow: column;
      width: 48px;
      height: auto;
      text-align: center;
      margin-left: auto;
      // margin-right: 4px;
      // img {
      //   width: 26.2px;
      //   height: 29.6px;
      //   margin-left: auto;
      // }
      i {
        font-size: 20px;
        color: #fff;
      }
    }
    > span {
      width: 234px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      color: #fff;
      font-size: 12px;
    }
  }
  .order {
    width: auto;
    max-height: 528.5px;
    margin: 10px 10px 20px;
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    > p {
      width: auto;
      height: 50px;
      display: flex;
      align-items: center;
      padding: 0 10px;
      img {
        width: 81px;
        height: 20px;
        margin-right: auto;
      }
      > span {
        color: #f19b3e;
        font-size: 15px;
        display: flex;
        align-items: center;
        i {
          font-size: 26px;
        }
      }
    }
    // .orderList {
    //   display: flex;
    //   flex-wrap: wrap;
    //   align-items: center;
    //   width: auto;
    //   height: auto;
    //   padding: 0 10px 10px;

    //   .lists {
    //     width: 107px;
    //     display: flex;
    //     flex-flow: column;
    //     margin-right: 7px;
    //     margin-bottom: 20.5px;
    //     position: relative;
    //     border-radius: 5px;
    //     .van-image {
    //       width: 161px;
    //       height: 161px;
    //     }
    //     .numbers {
    //       width: auto;
    //       height: 18px;
    //       display: flex;
    //       align-items: center;
    //       background: #feede5;
    //       border-radius: 0px 2px 9px 0px;
    //       position: absolute;
    //       top: 0;
    //       left: 0;
    //       img {
    //         width: 26px;
    //         height: 18px;
    //       }
    //       span:last-child {
    //         width: auto;
    //         padding: 0 2px;
    //         font-size: 10px;
    //         transform: scale(0.8);
    //         color: $tx-color;
    //       }
    //     }
    //     .van-count-down {
    //       width: 161px;
    //       height: 20px;
    //       // background: linear-gradient(to right, #a4e3ff 0%, #208fff 100%);
    //       // color: #944a24;
    //       //   transform: scale(0.83);
    //       font-size: 10px;
    //       line-height: 20px;
    //       text-align: center;
    //       font-weight: bold;
    //       position: absolute;
    //       top: 87px;
    //       border-radius: 0 0 10px 10px;
    //     }
    //     .names {
    //       width: 100%;
    //       height: fit-content;
    //       display: block;
    //       color: $fs-color;
    //       font-size: 13px;
    //       font-weight: bold;
    //       margin: 5px 0 2px;
    //       text-overflow: ellipsis;
    //       white-space: nowrap;
    //       overflow: hidden;
    //       word-break: break-all;
    //     }
    //     .factorys {
    //       // line-height: 20px;
    //       color: #208fff;
    //       font-size: 12px;
    //       display: block;
    //       margin: 2px 0;
    //       text-overflow: ellipsis;
    //       white-space: nowrap;
    //       overflow: hidden;
    //     }

    //     .money {
    //       width: 100%;
    //       display: block;
    //       color: $fs-color;
    //       font-size: 14px;
    //       margin: 5px 0 2px;
    //     }
    //     // .money::before {
    //     //   content: "分享赚";
    //     //   color: $fs-color;
    //     // }
    //     > p {
    //       height: 20px;
    //       line-height: 20px;
    //       display: flex;
    //       span:first-child {
    //         color: $tx-color;
    //         font-size: 15px;
    //         font-weight: bold;
    //       }
    //       span:last-child {
    //         color: #abacaf;
    //         font-size: 10px;
    //         text-decoration: line-through;
    //       }
    //     }
    //     .van-button {
    //       width: 100px;
    //       height: 25px;
    //       border-radius: 25px;
    //       margin: 10px auto 0;
    //       padding: 0;
    //       .van-button__text {
    //         font-weight: bold;
    //         font-size: 12px;
    //       }
    //     }
    //   }
    //   .lists:nth-child(3n + 3) {
    //     margin-right: 0;
    //   }
    //   .lists:last-child {
    //     margin-right: 0;
    //   }
    // }
  }
  .goGif {
    width: 345px;
    height: 30px;
    display: block;
    margin: 10px auto 34px;
  }
  /deep/.collage {
    width: 100%;
    height: fit-content;
    .van-tabs__line {
      // width: 20px !important;
      height: 0px;
    }
    .van-sticky--fixed {
      // position: sticky;
      top: 44px !important;
      z-index: 101;
      // padding-bottom: 10px;
    }
    .van-sticky {
      // background: #fff;
    }
    .van-tabs__wrap {
      width: 345px;
      height: 40px;
      // position: absolute;
      // left: 10px;
      // margin-right: 0;
      border-radius: 0 0 8px 8px;
      margin: 0 auto;
      .van-tabs__nav {
        background: #fff;
        .van-tab {
          // flex: none;
          // padding: 2px 4px;
          // margin-right: 8px;
          // width: 111px;
          height: 40px;
          position: relative;
        }
        .van-tab::after {
          content: "";
          width: 1.04px;
          height: 14px;
          background: #f4f4f4;
          position: absolute;
          right: 0;
          top: 14px;
        }
        .van-tab:nth-child(2)::after {
          background: #fff;
        }
      }
      .van-tab__text {
        font-size: 16px;
        display: flex;
        align-items: center;
        font-weight: bold;
        color: #333;
      }
      .van-tab--active {
        .van-tab__text {
          // font-size: 17px;
          // font-weight: bold;
        }
      }
    }

    .van-tabs__content {
      margin: 0 auto;
      width: 345px;
      height: fit-content;
      > span {
        font-size: 14px;
        color: #999;
        display: block;
        text-align: center;
        margin: 20px auto 10px;
      }
      .smallType {
        position: sticky;
        top: 84px;
        z-index: 100;
        padding-top: 10px;
        background: #f4f4f4;
        .van-sticky {
          border-radius: 8px;
        }
        .van-tabs {
          width: 375px;
          height: 51px;
          line-height: 51px;
          padding: 0;
          margin-left: -15px;
          .van-tabs__nav {
            height: 100%;
            background: #f4f4f4;
            display: flex;
            align-items: center;
          }
          .van-tabs__wrap {
            width: 100%;
            left: 0;
            height: 51px;
            line-height: 51px;
            border-radius: 8px;
          }
          .van-tab {
            width: 72px;
            height: 28px;
            flex: none;
            margin: 0 5px;
            padding: 0;
            text-align: center;
            line-height: 28px;
            text-overflow: ellipsis;
            overflow: hidden;
            background: #fff;
            box-sizing: content-box;
            box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.08);
            border-radius: 14px;
            .van-tab__text {
              font-size: 12px;
              height: 100%;
            }
          }
          .van-tab--active {
            background: #ff9a34;
            .van-tab__text {
              color: #fff;
            }
          }
          .van-tabs__line {
            height: 0;
          }
          [class*="van-hairline"]::after {
            border: none;
          }
          .van-tab::after {
            display: none;
          }
        }
        .van-tabs__content {
          display: none;
        }
      }
      .van-overlay {
        top: 345px;
      }
      .van-tab__pane {
        display: flex;
        flex-wrap: wrap;
        // margin-top: 19px;

        .collagelist {
          width: 325px;
          height: 141px;
          padding: 10px;
          display: flex;
          background: #ffffff;
          border-radius: 10px;
          position: relative;
          margin-top: 11px;
          border-radius: 5px;
          .van-image__img {
            width: 140px;
            height: 141px;
            flex: 0 0 140px;
            border-radius: 5px;
          }
          .times {
            width: 126px;
            // height: 28px;
            // background: #ff6e0d;
            color: #999999;
            font-size: 12px;
            margin-top: 4px;
            // display: block;
            // text-align: center;
            // font-weight: bold;
            // position: absolute;
            // top: 98px;
            // opacity: 0.9;
            // border-radius: 0 0 0 5px;
          }

          // .overlys {
          //   img {
          //     width: 40px;
          //     height: 39.5px;
          //     position: absolute;
          //     top: 0px;
          //     left: 0px;
          //   }
          // }
          .overlys {
            width: 83px;
            height: 83px;
            background: #000;
            opacity: 0.5;
            text-align: center;
            line-height: 83px;
            border-radius: 50%;
            position: absolute;
            left: 39px;
            top: 39px;
            z-index: 9;
            span {
              display: block;
              font-size: 18px;
              color: #fff;
            }
          }
          .texts {
            width: 183px;
            height: fit-content;
            padding: 3px 6px 4px;
            display: flex;
            flex: 1;
            flex-flow: column;
            .msdiv {
              // margin-top: 14px;
            }
            .shareName {
              height: 68px;
              display: flex;
              flex-flow: column;
              .countDown {
                height: 12px;
                display: flex;
                align-items: baseline;
                // margin: 6px 0;
              }
              .van-button {
                flex: 0 0 60px;
                border-radius: 4px;
              }
            }
            .names {
              // height: 42px;
              height: fit-content;
              color: $fs-color;
              font-size: 16px;
              font-weight: bold;
              display: -webkit-box;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              word-break: break-all;
            }

            .shareContent {
              width: fit-content;
              font-size: 12px;
              color: #dc0d0d;
              height: 16px;
              margin-top: 4px;
              padding: 2px 4px;
              border: 1.04px solid #dc0d0d;
              border-radius: 2px;
            }
            .snames {
              color: #208fff;
              font-size: 12px;
              padding: 2px 0;
              margin-bottom: 20px;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            }
            .dvtime {
              width: 70px;
              height: 18px;
              line-height: 18px;
              color: #999;
              border-radius: 2px;
              font-size: 12px;
              border: 1.04px solid #999;
              display: block;
              text-align: center;
            }
            .prices {
              margin: 0 0 2px;
              line-height: 20px;
              display: flex;
              align-items: center;
              > span:first-child {
                color: $tx-color;
                font-size: 17px;
                font-weight: bold;
                padding-right: 4px;
              }
              span:nth-child(2) {
                color: #999999;
                font-size: 12px;
                text-decoration: line-through;
              }
            }
            // .shopmoney {
            //   display: flex;
            //   margin: 0 0 12px;
            //   span:first-child {
            //     color: #999999;
            //     font-size: 12px;
            //     text-decoration: line-through;
            //   }
            // }
            .mt {
              margin: 8px 0;
            }
            .share {
              width: fit-content;
              height: 16px;
              padding: 3px 5px;
              background: #f8f8f8;
              border-radius: 15px;
              display: flex;
              align-items: center;
              font-weight: bold;
              > div {
                display: flex;
                align-items: center;
                height: 25px;
              }
              .money {
                color: $tx-color;
                font-size: 12px;
              }
              i {
                color: $tx-color;
              }
              // .money::before {
              //   content: "分享赚";
              //   color: $fs-color;
              // }
            }
            // .van-button {
            //   width: 54px;
            //   height: 25px;
            //   line-height: 25px;
            //   padding: 0;
            //   border: 1.5px solid rgba(255, 81, 78, 1);
            //   border-radius: 25px;
            //   margin-left: auto;
            //   .van-button__text {
            //     font-size: 14px;
            //     font-weight: bold;
            //     // color: #ff514e;
            //   }
            // }
            .hots {
              .van-button {
                width: 158px !important;
              }
            }
            .nums {
              width: auto;
              // height: 19px;
              // padding: 1.5px 4px;
              font-size: 12px;
              // background: #f3f3f3;
              color: #ababab;
              margin-top: 4px;
              border-radius: 3px;
              // margin-left: 4px;
              // text-align: center;
              white-space: nowrap;
              // line-height: 19px;
              span {
                // color: $tx-color;
              }
            }
            // .closes {
            //   // display: flex;
            //   // align-items: center;

            // }
            // .van-button {
            //   width: 71px;
            //   height: 26px;
            //   border-radius: 16px;
            //   .van-button__text {
            //     font-size: 14px;
            //     font-weight: normal;
            //   }
            // }
          }
        }
        .blacks {
          -webkit-filter: grayscale(100%) opacity(50%);
          -moz-filter: grayscale(100%) opacity(50%);
          -ms-filter: grayscale(100%) opacity(50%);
          -o-filter: grayscale(100%) opacity(50%);
          filter: grayscale(100%) opacity(50%);
          filter: gray;
          filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
        }
        .tags {
          width: 140px;
          height: 25px;
          text-align: center;
          line-height: 25px;
          background: linear-gradient(to right, #a4e3ff 0%, #208fff 100%);
          font-size: 12px;
          color: #fff;
          border-radius: 0 0 5px 5px;
          position: absolute;
          left: 10px;
          bottom: 10px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
    }
    .ms {
      width: auto;
      height: 15px;
      padding-left: 2px;
    }
    .activeImg {
      width: 27px;
      height: 11px;
      position: absolute;
      bottom: 2px;
      left: 0;
      right: 0;
      margin: 0 auto;
    }
  }
}

//公共部分
.commission {
  color: #ff1310;
  font-size: 12px;
  display: block;
  margin-left: 7px;
  // margin-right: 8px;
  white-space: nowrap;
}

.topTabs {
  /deep/.van-tabs__wrap {
    width: 345px;
    height: 35px;
    margin: 0 auto;
    margin-top: 15px;
    border-radius: 8px 8px 0 0;
    .van-tabs__nav {
      width: 100%;
      height: 100%;
      padding-bottom: 0;
      .van-tab--active {
        background: #fff;
        font-weight: bold;
        font-size: 16px;
      }
    }
  }
}
.sty {
  /deep/.van-tabs__wrap {
    border-radius: 8px;
  }
}
/deep/.van-tabs__line {
  height: 0;
}
/deep/[class*="van-hairline"]::after {
  border: none;
}
.nulls {
  margin: 130px auto;
  display: flex;
  flex-flow: column;
  align-items: center;
  i {
    font-size: 100px;
    color: #d5d5d5;
  }
  span {
    color: #a3a2a2;
    font-size: 15px;
    padding-top: 6px;
  }
}

// 2021.1.29
.numbers {
  width: auto;
  padding: 2px 6px;
  height: 15px;
  line-height: 18px;
  border-radius: 7.5px;
  position: absolute;
  left: 15px;
  top: 15px;
  background: rgba(0, 0, 0, 0.5);
  .nums {
    color: #fff;
    font-size: 11px;
  }
}

.btn_group {
  display: flex;
  margin-top: 2px;
  .van-button {
    padding: 0;
    border: 1.5px solid rgba(255, 81, 78, 1);
    border-radius: 25px;
    // margin-left: auto;
  }
  .copy {
    width: 99px;
    height: 26px;
  }
  .van-button:not(.copy) {
    width: 71px;
    height: 26px;
    border-radius: 16px;
    margin-left: auto;
  }
}

#copy-txt {
  position:absolute;
  top:-999em;
  white-space: pre-line;
}
</style>
